// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Hleb Serafimovich <hleb.serafimovich@celadon.ae>

import { put, call, takeEvery } from 'redux-saga/effects';

import * as arrangeCollectionActions from './actions';
import {
  getArrangeCollectionStatus, getBookCollectionStatus, validatePhoneNumberService
} from './service';
import * as types from './actionTypes';


function* getArrangeCollectionStatusSaga(payload) {

  yield put(arrangeCollectionActions.startLoader());
  const { orderId } = payload;
  const token = localStorage.getItem('token');
  const customerId = localStorage.getItem('loggedID');
  const res = yield call(getArrangeCollectionStatus, { customerId, token, orderId });
  if (res.ok && res.body) {
    const status = res.body.CollectOrderFromHomeResult;
    yield put(arrangeCollectionActions.setStatus(status));
  }
  yield put(arrangeCollectionActions.stopLoader());
}

function* getBookCollectionStatusForTrade1Saga(payload) {

  yield put(arrangeCollectionActions.startLoader());
  const { data } = payload;
  const res = yield call(getBookCollectionStatus, data);
  if (res.ok) {
    const status = res.body;
    yield put(arrangeCollectionActions.setStatus(status));
    yield put(arrangeCollectionActions.bookCollectionForTrade1Success());
  }
  yield put(arrangeCollectionActions.stopLoader());
}

function* getBookCollectionStatusForTrade2Saga(payload) {

  yield put(arrangeCollectionActions.startLoader());
  const { data } = payload;

  const date = new Date(data.PickupDate);
  let month = date.getMonth() + 1;
  month = month < 10 ? `0${month}` : `${month}`;
  const day = date.getDate() < 10 ? `0${date.getDate()}` : `${date.getDate()}`;
  const strDate = `${date.getFullYear()}-${month}-${day}`;

  const res = yield call(getBookCollectionStatus, { ...data, PickupDate: strDate });

  if (res.ok) {
    const status = res.body;
    yield put(arrangeCollectionActions.setStatus(status));
    yield put(arrangeCollectionActions.bookCollectionForTrade2Success());
  }
  yield put(arrangeCollectionActions.stopLoader());
}

function* validatePhoneNumberSaga(payload) {
  const { dataForNextRequest } = payload;
  let errorText;
  if (payload.data.phone_number) errorText = 'Invalid mobile number.';
  else errorText = 'Please enter your mobile number.';

  const res = yield call(validatePhoneNumberService, payload.data);

  if (res.ok) {
    if (res.body.result && res.body.carrier.type === 'mobile') {
      yield put(arrangeCollectionActions.setIsButtonPressed(true));
      yield put(arrangeCollectionActions.bookCollectionForTrade2(dataForNextRequest));
    } else {
      yield put(arrangeCollectionActions.validatePhoneNumberFailed(errorText));
    }
  }
}


const arrangeCollectionSagas = [
  takeEvery(types.ARRANGE_COLLECTION_REQUEST, getArrangeCollectionStatusSaga),
  takeEvery(types.BOOK_COLLECTION_FOR_TRADE_1, getBookCollectionStatusForTrade1Saga),
  takeEvery(types.BOOK_COLLECTION_FOR_TRADE_2, getBookCollectionStatusForTrade2Saga),
  takeEvery(types.VALIDATE_PHONE_NUMBER, validatePhoneNumberSaga),
];

export default arrangeCollectionSagas;
